import { Button } from "@/components/ui/button";
import lottie from "lottie-web";
import { ArrowRight, Check } from "lucide-react";
import { useEffect, useRef } from "react";
import { FaStar } from "react-icons/fa";
import { Link } from "react-router-dom";

interface HeroSectionCityProps {
  cityName?: string;
}

export function HeroSectionCity({ cityName }: HeroSectionCityProps) {
  const animationContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (animationContainer.current) {
      const anim = lottie.loadAnimation({
        container: animationContainer.current,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: "/animation/processo-de-compra.json",
      });

      return () => anim.destroy();
    }
  }, []);

  return (
    <section className=" py-10 md:py-24 lg:py-32 bg-n-bg-1">
      <div className="container">
        <div className="grid gap-8 md:grid-cols-2">
          <div className="text-left">
            <p className="text-lg text-n-green font-semibold lg:mb-8 mb-4">
              &gt; Localidades
            </p>
            <h1
              className="mb-6 text-4xl font-normal text-n-green md:text-5xl lg:text-6xl"
              style={{ fontFamily: "'Anton', sans-serif", lineHeight: "1.2em" }}
            >
              Transporte de Veículos em {cityName || "Sua cidade"}
            </h1>
            <div className="hidden md:flex md:gap-6 gap-1 mb-6">
              <div className="flex gap-1 items-center border rounded-full border-n-neutral-lighter py-1 px-3 h-[34px]">
                <img src="/icons/reclameaqui.png" alt="Reclame aqui" />
                <p className="text-n-text-neutral font-medium text-xs">
                  Somos nota máxima no Reclame Aqui!
                </p>
              </div>
              <div className="flex gap-1 items-center border rounded-full border-n-neutral-lighter py-1 px-3 h-[34px]">
                <img src="/icons/icoGG.png" alt="google" />
                <p className="text-n-text-neutral font-medium text-xs flex items-center gap-1.5">
                  <FaStar className="text-n-text-neutral w-3 h-3" /> 5 estrelas
                  no Google!
                </p>
              </div>
            </div>

            <p className="mb-6 text-n-green text-lg">
              A Nacional GO é a sua plataforma digital para o transporte de
              veículos. De {cityName || "Sua cidade"} para mais de 3.500
              cidades, com mais de 10.000 transportadores cadastrados. Já
              transportamos mais de 200.000 veículos. Faça a sua cotação online
              e rápida agora!
            </p>

            <div className="flex gap-3 items-center mb-8">
              <div className="flex items-center gap-2 border border-n-neutral-lighter rounded-full h-10">
                <div className="bg-n-beige px-3 rounded-r-none rounded-l-full h-full flex items-center">
                  <Check className="w-5 h-5 text-n-green" />
                </div>
                <span className="text-sm text-n-text-neutral font-semibold pl-2 pr-4">
                  Cotação em segundos, sem burocracia
                </span>
              </div>
            </div>
            <Link to="/fazer-cotacao">
              <Button id="btn-fazer-cotacao">
                Agendar meu transporte <ArrowRight className="ml-2 " />
              </Button>
            </Link>
          </div>

          <div className="flex items-center justify-center">
            <div
              ref={animationContainer}
              className="h-[500px] w-full max-w-[300px]"
              aria-label={`Transporte de Veículos em ${
                cityName || "Sua cidade"
              }`}
            ></div>
          </div>
        </div>
      </div>
    </section>
  );
}
